<template lang="pug">
div
	.card
		.card-header
			span.fa.fa-calendar.mr-2
			| Próximos eventos
		vc-calendar(
			ref="calendar"
			is-expanded,
			:attributes="fechasCalendario"
			:firstDayOfWeek="2"
			@update:from-page="getEventos(mesAno=$event)"
			@dayclick="setPopover($event.id)"
		)
		button(@click="moveToday" type="button")
			|Hoy
	br
	AddEvent(ref="addEvent" :popoverDate="popoverDate" @updateEvents="getEventos(mesAno)")
</template>

<script>
import Servicios from '../../servicios'
import AddEvent from './addEvent'
export default {
	components: {
		AddEvent
	},
	data () {
		return {
			fechasCalendario: [],
			popoverDate: null
		}
	},
	created () {
		this.popoverDate = this.getToday()
		this.getEventos({
			year: new Date().getFullYear(),
			month: new Date().getMonth() + 1
		})
	},
	methods: {
		setPopover (e) {
			this.popoverDate = e
		},
		getEventos (e) {
			if (!e) {
				this.getEventos({
					year: new Date().getFullYear(),
					month: new Date().getMonth() + 1
				})
			} else {
				Servicios.getEventos(e.year, e.month)
					.then(eventos => {
						this.fechasCalendario = eventos
					})
					.catch(e => {
						this.$error(e)
					})
			}
		},
		moveToday () {
			var calendar = this.$refs.calendar
			calendar.move(new Date())
			this.popoverDate = this.getToday()
		},
		getToday () {
			let fechaCompleta = new Date()
			let month = fechaCompleta.getMonth() + 1
			return fechaCompleta.getFullYear() + '-' + month + '-' + fechaCompleta.getDate()
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/modulos/muro/vue/componentes/calendario/calendario.vue